import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetMappingDeviceFirmwareDevicesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MappingDeviceFirmwareDeviceFilterInput>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Types.MappingDeviceFirmwareDeviceSortInput> | Types.MappingDeviceFirmwareDeviceSortInput>;
}>;


export type GetMappingDeviceFirmwareDevicesQuery = { mappingDeviceFirmwareDevices?: Maybe<{ __typename?: 'MappingDeviceFirmwareDeviceCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'MappingDeviceFirmwareDevice', id: string, deviceId: string, userId?: Maybe<string>, deviceFirmwareId: string, dateTo: string, dateFrom: string, mappingDeviceFirmwareDeviceStatus: { __typename?: 'MappingDeviceFirmwareDeviceStatus', id: string, statusName: string }, deviceFirmware: { __typename?: 'DeviceFirmware', id: string, firmwareVersion: string } }>> }> };


export const GetMappingDeviceFirmwareDevicesDocument = gql`
    query getMappingDeviceFirmwareDevices($where: MappingDeviceFirmwareDeviceFilterInput, $take: Int, $skip: Int, $order: [MappingDeviceFirmwareDeviceSortInput!]) {
  mappingDeviceFirmwareDevices(where: $where, take: $take, skip: $skip, order: $order) {
    totalCount
    items {
      id
      deviceId
      userId
      deviceFirmwareId
      dateTo
      dateFrom
      mappingDeviceFirmwareDeviceStatus {
        id
        statusName
      }
      deviceFirmware {
        id
        firmwareVersion
      }
    }
  }
}
    `;

/**
 * __useGetMappingDeviceFirmwareDevicesQuery__
 *
 * To run a query within a React component, call `useGetMappingDeviceFirmwareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingDeviceFirmwareDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingDeviceFirmwareDevicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMappingDeviceFirmwareDevicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMappingDeviceFirmwareDevicesQuery, GetMappingDeviceFirmwareDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMappingDeviceFirmwareDevicesQuery, GetMappingDeviceFirmwareDevicesQueryVariables>(GetMappingDeviceFirmwareDevicesDocument, options);
      }
export function useGetMappingDeviceFirmwareDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMappingDeviceFirmwareDevicesQuery, GetMappingDeviceFirmwareDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMappingDeviceFirmwareDevicesQuery, GetMappingDeviceFirmwareDevicesQueryVariables>(GetMappingDeviceFirmwareDevicesDocument, options);
        }
export type GetMappingDeviceFirmwareDevicesQueryHookResult = ReturnType<typeof useGetMappingDeviceFirmwareDevicesQuery>;
export type GetMappingDeviceFirmwareDevicesLazyQueryHookResult = ReturnType<typeof useGetMappingDeviceFirmwareDevicesLazyQuery>;
export type GetMappingDeviceFirmwareDevicesQueryResult = Apollo.QueryResult<GetMappingDeviceFirmwareDevicesQuery, GetMappingDeviceFirmwareDevicesQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
